import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material } from '@wonderlandengine/api';

/**
 * Carpet Description:
 */
export class CarpetDescription extends Component {
	static TypeName = 'carpet-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	carpetId: string = '';

	@property.material()
	carpetMaterial: Material | null = null;
}